export default "__VITE_ASSET__$dSmjvzW__"